import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { IEventMessage } from '../../interfaces/IEventMessage';
import { Subscription } from 'rxjs/Subscription';


type onNext = (data: IEventMessage) => any;

@Injectable()
export class BroadcastService {
  private subject = new  Subject<IEventMessage>();

  private observableSubject = this.subject.asObservable();

  nowidgets = new Subject();

  broadcast(data: IEventMessage) {
    this.subject.next(data);
  }

  subscribe(onnext: onNext): Subscription {
    return this.observableSubject.subscribe(onnext);
  }

}



// WEBPACK FOOTER //
// ./app/services/broadcast/broadcast.service.ts